<app-notifications></app-notifications>
<div class="checking-credit-worthiness" *ngIf="loading">
    <p>Resta in attesa delle verifiche in corso per poter procedere...</p>
    <app-progress></app-progress>
</div>
